import type { Transition } from "@uirouter/react";

import Sentry from "@similarweb/sentry-logger";

export const logWithTransitionScope = (
    transition: Transition,
    phase: "onEnter" | "redirectTo",
    message: string,
    options?: { redirectTargetStateName?: string; tags?: Record<string, string> },
): void => {
    Sentry.withScope((scope) => {
        scope.setTag("transition.phase", phase);
        scope.setTag("transition.fromStateName", transition.from().name);
        scope.setTag("transition.requestedToStateName", transition.to().name);
        if (options?.redirectTargetStateName) {
            scope.setTag("transition.redirectTargetStateName", options.redirectTargetStateName);
        }
        Sentry.log(message, options?.tags ? { tags: options.tags } : undefined);
    });
};
